module.exports = __webpack_public_path__ + "media/images/sport--biathlon-e937c47c19fa806326772d90af31450a.png";